// "Partner portal events" tracking sheet → Sidebar, Tier 1. Labels are the sheet's
// event names verbatim. Travel / Bookings / Reports / Settings are the collapsible
// section headers; the items inside them are Tier 2 in the sheet.
export const sidebar_events = {
  sidebar_dashboard_click: {
    category: 'Sidebar',
    action: 'Dashboard click',
    label: 'sidebar-dashboard-click',
  },
  sidebar_travel_click: {
    category: 'Sidebar',
    action: 'Travel section click',
    label: 'sidebar-travel-click',
  },
  sidebar_bookings_click: {
    category: 'Sidebar',
    action: 'Bookings section click',
    label: 'sidebar-bookings-click',
  },
  sidebar_reports_click: {
    category: 'Sidebar',
    action: 'Reports section click',
    label: 'sidebar-reports-click',
  },
  sidebar_settings_click: {
    category: 'Sidebar',
    action: 'Settings section click',
    label: 'sidebar-settings-click',
  },
};
